import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'

import { BiztelAccountMappingComponent } from './biztel-account-mapping.component'

/**
 * 連携対象ユーザー設定 UI (`app-biztel-account-mapping`) をダイアログ表示するための
 * 薄いラッパー。インライン部品をそのまま埋め込み、ヘッダーと閉じる導線だけを足す。
 * 部品が自前で fetch するため MAT_DIALOG_DATA は受け取らない。
 */
@Component({
  selector: 'app-biztel-account-mapping-dialog',
  standalone: true,
  imports: [MatIcon, BiztelAccountMappingComponent],
  templateUrl: './biztel-account-mapping-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './biztel-account-mapping-dialog.component.scss',
})
export class BiztelAccountMappingDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<BiztelAccountMappingDialogComponent>,
  ) {}

  close(): void {
    this.dialogRef.close()
  }
}
